import { BadRequestError } from "./base.error.js";

export class InvalidWhatsAppIdError extends BadRequestError {
  constructor(public readonly invalidValue: string) {
    super(
      `Invalid WhatsApp ID: '${invalidValue}'. Expected format: valid wa_id without + prefix (e.g., 14155551234)`,
    );
    Object.defineProperty(this, "name", {
      value: "InvalidWhatsAppIdError",
    });
  }
}
